import * as api from '../util/apis';
import { ENV } from '../constants/Constants';
import { Client } from '@horasys/bellplus/common/types';
import { BusinessCategory } from '@horasys/bellplus/common/types';
import { getJsonFromClient, getClientFromJson } from '../jsonutils/client';

export const getClients = async (): Promise<Array<Client>> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.client);
		const clientList: Array<Client> = resp.data.data;
		clientList.forEach((client: Client) => {
			client.name = client.companyName ?? client.firstName + ' ' + client.lastName;
		});
		return Promise.resolve(clientList);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getClientById = async (clientId: number): Promise<Client> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.client + '/' + clientId);
		const client: Client = await getClientFromJson(resp.data.data);

		return Promise.resolve(client);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getBusinessCategories = async (): Promise<Array<BusinessCategory>> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.businessCategory);
		const businessCategoriesList: Array<BusinessCategory> = resp.data.data;
		return Promise.resolve(businessCategoriesList);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createClient = async (client: Client): Promise<any> => {
	try {
		const requestData: any = getJsonFromClient(client, false);
		const resp = await api.postapiresponses(ENV.dev.client, requestData);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateClientDetails = async (client: Client): Promise<any> => {
	try {
		const requestData: any = getJsonFromClient(client, true);
		const resp = await api.putapiresponses(
			ENV.dev.client + '/' + client.id,
			requestData,
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const checkUserName = async (enteredUserName: string): Promise<boolean> => {
	try {
		const resp: any = await api.login(ENV.dev.userSearch + '/username', {
			username: enteredUserName,
		});

		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteClient = async (clientId: number): Promise<any> => {
	try {
		const resp = await api.deleteapiresponses(ENV.dev.client + '/' + clientId);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const checkCompanyName = async (enteredComapanyName: string): Promise<boolean> => {
	try {
		const resp: any = await api.login(
			ENV.dev.company + `/client?companyName=${enteredComapanyName}`,
			{},
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};
